<template>
  <div class="text-center">
    <v-dialog
      v-model="modalPdfStatus"
      max-width="1000px"
      persistent
      scrollable
    >
      <v-card min-height="90vh">
        <v-card-title class="pa-0">
          <div class="d-flex flex-row flex-grow-1 align-center justify-space-between py-2 px-8">
            <div class="d-flex flex-row align-center justify-start">
              <v-icon color="#959595" class="mr-2">mdi-file-pdf-box</v-icon>
              <p class="mb-0 font-weight-bold text-primary body-1">{{ pdfTitle }}</p>
            </div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  dark
                  small
                  color="#959595"
                  @click="closePdfModal"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark>mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Cerrar</span>
            </v-tooltip>
          </div>
        </v-card-title>
        <v-card-text class="pa-0">
          <div v-if="isLoading" class="d-flex align-center justify-center" style="min-height: 500px;">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
          <iframe v-else :src="pdfUrl" width="100%" class="fill-height d-flex flex-grow-1" style="min-height: 500px;"></iframe>
        </v-card-text>
        <v-card-actions class="pa-0">
          <div class="d-flex flex-grow-1 justify-end py-2 px-8">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  depressed
                  color="green"
                  class="mb-0"
                  small
                  v-bind="attrs"
                  v-on="on"
                  dark
                  :loading="isSendingEmail"
                  @click="sendEmailWithCostTable"
                >
                  <v-icon small>mdi-email-outline</v-icon>
                  <p class="mb-0 ml-2 caption">Enviar por Email a Cliente</p>
                </v-btn>
              </template>
              <span>Se enviará el PDF al correo del cliente</span>
            </v-tooltip>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { sendTableCostTotalsToClient } from '@/helpers/api/costs'

export default {
  name: 'CostPdfModal',
  data: () => ({
    pdfUrl: null,
    isLoading: false,
    isSendingEmail: false,
  }),
  computed: {
    modalPdfStatus() {
      return !!this.$store.state.costbreakdown.costPdfModal
    },
    pdfModal() {
      return this.$store.state.costbreakdown.costPdfModal || {}
    },
    pdfTitle() {
      const type = this.pdfModal.type
      if (type === 'supervision') {
        return `Tabla de Patrocinio ${this.pdfModal.table_number || ''}`
      }
      return 'Resumen de Estados de Pago'
    },
  },
  watch: {
    modalPdfStatus: {
      async handler(newVal) {
        if (newVal && this.pdfModal.requestData) {
          await this.generatePdf()
        }
      },
      immediate: true
    }
  },
  methods: {
    async generatePdf() {
      try {
        this.isLoading = true
        const { generateTableCostTotalsPdf, generateSupervisionTablePdf } = await import('@/helpers/api/costs')
        
        let response
        if (this.pdfModal.type === 'supervision') {
          response = await generateSupervisionTablePdf(this.pdfModal.requestData)
        } else {
          response = await generateTableCostTotalsPdf(this.pdfModal.requestData)
        }
        
        if (response.code === 200 && response.pdf_url) {
          this.pdfUrl = response.pdf_url
        }
      } catch (error) {
        console.error('Error generating PDF:', error)
        this.setMessage({
          message: 'Error al generar el PDF',
          title: 'Ha ocurrido un error',
          type: 'danger',
          icon: 'mdi-close-octagon',
          color: '#FF1209',
        })
        this.closePdfModal()
      } finally {
        this.isLoading = false
      }
    },
    async sendEmailWithCostTable() {
      try {
        this.isSendingEmail = true
        
        if (this.pdfModal.type === 'supervision') {
          // Para supervision, no enviamos email desde aquí
          // Asumimos que se maneja diferente o simplemente cerramos
          this.setMessage({
            message: 'Función no implementada para tablas de patrocinio',
            title: 'Info',
            type: 'info',
            icon: 'mdi-information',
            color: '#2196F3',
          })
        } else {
          // Para cost totals, llamamos a sendTableCostTotalsToClient
          const response = await sendTableCostTotalsToClient(this.pdfModal.requestData)
          
          if (response.code === 200) {
            this.setMessage({
              message: 'Resumen de estados de pago enviado correctamente al correo del cliente.',
              title: 'Éxito',
              type: 'success',
              icon: 'mdi-check-circle-outline',
              color: '#4CAF50',
            })
            this.closePdfModal()
          }
        }
      } catch (error) {
        console.error('Error sending email:', error)
        this.setMessage({
          message: 'Hubo un error en la operación, por favor intenta nuevamente',
          title: 'Ha ocurrido un error',
          type: 'danger',
          icon: 'mdi-close-octagon',
          color: '#FF1209',
        })
      } finally {
        this.isSendingEmail = false
      }
    },
    closePdfModal() {
      this.$store.commit('costbreakdown/setCostPdfModal', null)
    },
    setMessage(messageData) {
      this.$store.dispatch('general/addMessage', messageData)
    },
  }
}
</script>

<style scoped>
.text-primary {
  color: #524D4D;
}
</style>
